module.exports = __webpack_public_path__ + "media/images/start_footer_default-483fae834ec7448d6b865471e2789c10.webp";